export default "__VITE_ASSET__DekQqy2c__"